module.exports = __webpack_public_path__ + "img/basketball.svg";